module.exports = __webpack_public_path__ + "img/phoebetreff.2bfa1765.jpg";